import React, { useContext, useImperativeHandle } from 'react';

const PermissionsContext = React.createContext({
  isActionAllowed: () => false,
});

export const PermissionsProvider = React.forwardRef(
  ({ children, actions = [], isolate = false }, ref) => {
    const { isActionAllowed } = useContext(PermissionsContext);

    const handleIsActionAllowed = actionId => {
      if (actions.includes(actionId)) {
        return true;
      } else if (!isolate) {
        return isActionAllowed(actionId);
      }
    };

    const permissionsBag = {
      isActionAllowed: handleIsActionAllowed,
    };

    useImperativeHandle(ref, () => ({
      ...permissionsBag,
    }));

    if (typeof children === 'function') {
      children = children(permissionsBag);
    }

    return (
      <PermissionsContext.Provider
        value={{
          ...permissionsBag,
        }}
      >
        {children}
      </PermissionsContext.Provider>
    );
  }
);

export default PermissionsContext;
